import { Action } from 'redux';
import {
    DefaultEditors,
    DashboardSettings
} from '@dev/ee-api/ee-api-models';


export enum DashboardSettingsActionTypes {
    SET_DEFAULT_EDITOR = '@@dashboardsettings/SET_ACCOUNT_DEFAULT_EDITOR',
    SET_DEFAULT_EDITOR_SUCCESS = '@@dashboardsettings/SET_ACCOUNT_DEFAULT_EDITOR_SUCCESS',
    SET_DEFAULT_EDITOR_ERROR = '@@dashboardsettings/SET_ACCOUNT_DEFAULT_EDITOR_ERROR',
    GET_DASHBOARD_SETTINGS = '@@dashboardsettings/GET_ACCOUNT_DASHBOARD_SETTINGS',
    GET_DASHBOARD_SETTINGS_SUCCESS = '@@dashboardsettings/GET_ACCOUNT_DASHBOARD_SETTINGS_SUCCESS',
    GET_DASHBOARD_SETTINGS_ERROR = '@@dashboardsettings/GET_ACCOUNT_DASHBOARD_SETTINGS_ERROR',
}

export interface GetDashboardSettingsAction extends Action {
    type: DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS;
}
export interface GetDashboardSettingsSuccessAction extends Action {
    type: DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS_SUCCESS;
    payload: {
        dashboardSettingsList: DashboardSettings;
    };
}
export interface GetDashboardSettingsErrorAction extends Action {
    type: DashboardSettingsActionTypes.GET_DASHBOARD_SETTINGS_ERROR;
}

export interface SetDefaultEditorAction extends Action {
    type: DashboardSettingsActionTypes.SET_DEFAULT_EDITOR;
    payload: {
        defaultEditor: DefaultEditors;
        showSuccessToast?: boolean;
    }
}
export interface SetDefaultEditorSuccessAction extends Action {
    type: DashboardSettingsActionTypes.SET_DEFAULT_EDITOR_SUCCESS;
}
export interface SetDefaultEditorErrorAction extends Action {
    type: DashboardSettingsActionTypes.SET_DEFAULT_EDITOR_ERROR;
}

export interface DashboardSettingsState {
    dashboardSettingsList?: DashboardSettings;
    dashboardSettingsLoading?: boolean;
    setDefaultEditorLoading?: boolean;
}
